/*───────────────────────────────────────────────────────────────
 🌐 Project: Ring2All Platform
 🧑‍💻 Author: Rodrigo Cuadra
 🏢 Company: Ring2All LLC
 📄 File: label.tsx
 🗓️ Created: 2025-01-05
 🧩 Description:
    Label component for form field labels with consistent styling
    and accessibility features throughout the platform.

 🔧 Notes:
    - Implements proper label semantics for form accessibility
    - Supports custom className and children props
    - Integrates with Tailwind CSS for consistent styling
    - Provides proper focus management and screen reader support
    - Maintains design system consistency

 🔁 Last Updated: 2025-01-05 by Rodrigo Cuadra
────────────────────────────────────────────────────────────────*/

import { ReactNode, LabelHTMLAttributes } from 'react';

interface LabelProps extends LabelHTMLAttributes<HTMLLabelElement> {
  children: ReactNode;
  className?: string;
  required?: boolean;
}

export function Label({ children, className = '', required = false, ...props }: LabelProps) {
  return (
    <label
      className={`text-sm font-medium text-gray-700 dark:text-gray-300 cursor-default ${className}`}
      {...props}
    >
      {children}
      {required && <span className="text-red-500 ml-1">*</span>}
    </label>
  );
}
